import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { ITradeWithUniproofAndDocuments } from "../interface/trade/ITradeWithUniproofAndDocuments";
import { ITrade } from "../interface/trade/ITrade";

enum UniproofServiceEnum {
  contingency = "/create-contingency",
  getReport = "/get-trades"
}

export default class UniproofService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/uniproof");
  }
  public postContingency = async (tradeId: number, category: string): Promise<ITrade> =>
    await this.POST(UniproofServiceEnum.contingency + `?tradeId=${tradeId}&category=${category}`, null);
  public getReport = async (): Promise<ITradeWithUniproofAndDocuments[]> => await this.GET(UniproofServiceEnum.getReport);
}
